import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../@shared/shared.module';
import { PagesRoutingModule } from './pages-routing.module';
import { LayoutComponent } from '../layout/layout.component';
//import { UpcomingComponent } from '../layout/upcoming/upcoming.component';
//import { TopnavComponent } from '../layout/topnav/topnav.component';
// import { FooterComponent } from '../layout/footer/footer.component';
import { RulesPageComponent } from './rules-page/rules-page.component';
import { SportsBookComponent } from './sports-book/sports-book.component';
import { SportLayoutComponent } from '../layout/sport-layout/sport-layout.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountProfileComponent } from './account-profile/account-profile.component';
import { DepositWithdrawComponent } from './deposit-withdraw/deposit-withdraw.component';
import { MyBetListComponent } from './my-bet-list/my-bet-list.component';

@NgModule({
  declarations: [
    LayoutComponent,
    SportLayoutComponent,
    //UpcomingComponent,
    //TopnavComponent,
    // FooterComponent,
    RulesPageComponent,
    SportsBookComponent,
    ChangePasswordComponent,
    AccountProfileComponent,
    DepositWithdrawComponent,
    MyBetListComponent,
  ],
  imports: [CommonModule, PagesRoutingModule, SharedModule],
  providers: [],
})
export class PagesModule {}
